/******************************************************************************
 *
 * Copyright (c) 2019-2023 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Rahul Bagaria' <Rahul@wakencode.com>, November 2023
 *
 *****************************************************************************/

/**
 * This page is used for routing purpose
 */

import { Routes as ReactRoute, Route } from "react-router-dom";
import { Suspense, lazy } from "react";
import { Loading } from "../components/loading";
import { ROUTES } from "../../model/constants/routes";
import WorkOrderImages from "../pages/workOrderImages";


const PageNotFound = lazy(() => import("../pages/pageNotFound"));

/**
 * This is a functional componant for Routes
 * @returns JSX for Routes
 */
const Routes = () => {

  return (
    <Suspense fallback={<Loading />}>
      <ReactRoute>
        <Route path={ROUTES.HOME} element={<PageNotFound />} />

        <Route
          path={`${ROUTES.WORK_ORDERS}/:workOrderId`}
          element={<WorkOrderImages />}
        />

        <Route path="*" element={<PageNotFound />} />
      </ReactRoute>
    </Suspense>
  );
};

export default Routes;
